module.exports = "/virtual-football-league/img/amblems/right/logos/Marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Marseille.png
// module id = 2215
// module chunks = 4